var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E9E61C",
    d: "M16.5556444,11.8149375 C15.453616,11.8149375 14.3715563,11.6425781 13.3461684,11.3037187 C12.8437166,11.1323437 12.2260463,11.2895625 11.9193908,11.6045156 L9.89547423,13.1323594 C7.54830847,11.8794375 6.10249973,10.4340937 4.86669045,8.10454687 L6.34957721,6.13335938 C6.73484184,5.74860938 6.87302898,5.18657812 6.70746691,4.65923437 C6.36715529,3.62845313 6.19428074,2.54690625 6.19428074,1.44440625 C6.19432762,0.647953125 5.54637618,0 4.74997201,0 L1.44435561,0 C0.647951438,0 0,0.647953125 0,1.44435937 C0,10.5732656 7.42676191,18 16.5556444,18 C17.3520486,18 18,17.3520469 18,16.5556406 L18,13.25925 C18,12.4628906 17.3520017,11.8149375 16.5556444,11.8149375 Z"
  })));
}

export default __webpack_public_path__ + "static/phone-05ba5bad749cd14f79a7f01f67bd3b6b.svg";
export { SvgPhone as ReactComponent };